if (!customElements.get('lv-sofa-gift')) {
  customElements.define('lv-sofa-gift', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => this.sync();
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onChange);
      this.sync();
      this.timer = setInterval(() => this.sync(), 30000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.removeEventListener('change', this.onChange); this.removeEventListener('input', this.onChange); }
    sync() {
      const active = Number.isFinite(Date.parse(this.dataset.end)) && Date.now() < Date.parse(this.dataset.end);
      this.hidden = !active;
      const choice = this.querySelector('input[type="radio"]:checked')?.value;
      const property = this.querySelector('[data-gift-property]');
      const color = this.querySelector('[data-gift-color]');
      const throwColor = this.querySelector('[data-throw-color]');
      const throwOption = throwColor?.selectedOptions[0];
      const throwImage = this.querySelector('[data-throw-image]');
      if (throwOption && throwImage) { throwImage.src = throwOption.dataset.image; throwImage.alt = `Plaid LOMVOR ${throwColor.value}`; }
      const throwChooser = this.querySelector('[data-throw-colors]');
      if (throwChooser) throwChooser.hidden = choice !== 'throw';
      if (color) color.closest('.lv-gift__color-choice').hidden = choice !== 'cushions';
      const selectedColor = color?.selectedOptions[0];
      if (selectedColor) this.querySelectorAll('.lv-gift__pair img').forEach(img => {img.src = selectedColor.dataset.image; img.alt = `Petit coussin ${color.value}`;});
      if (!active || choice === 'none') { property.removeAttribute('name'); property.value = ''; }
      else { property.name = 'properties[Cadeau offert par canapé]'; property.value = choice === 'cushions' ? `Deux petits coussins — ${color?.value || this.dataset.color} (même coloris pour la paire)` : `Plaid LOMVOR — ${throwColor?.value || 'Beige'}`; }
      let total = 0;
      this.querySelectorAll('[data-gift-extra]').forEach(row => {
        const quantity = row.querySelector('[data-extra-quantity]');
        const n = Math.min(10, Math.max(0, parseInt(quantity.value, 10) || 0)); quantity.value = n;
        const option = row.querySelector('[data-extra-color]')?.selectedOptions[0];
        if (!option) return;
        const unit = Number(option.dataset.unitPrice);
        if (row.dataset.extraKind === 'throw') {
          total += n * unit;
          row.querySelector('img').src = option.dataset.image;
          row.querySelector('img').alt = `Plaid LOMVOR ${option.value}`;
          return;
        }
        const pair = Number(option.dataset.pairPrice);
        total += Math.floor(n / 2) * pair + (n % 2) * unit;
        row.querySelector('img').src = option.dataset.image;
        row.querySelector('img').alt = `Coussin ${option.value}`;
        const saving = Math.floor(n / 2) * (2 * unit - pair);
        row.querySelector('[data-saving]').textContent = saving ? `${saving / 100} € économisés · prix duo appliqué` : `${(2 * unit - pair) / 100} € économisés par duo`;
      });
      const output = this.querySelector('[data-extra-total]');
      if (output) output.textContent = `Accessoires supplémentaires : ${new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR'}).format(total / 100)}`;
    }
    getItems() {
      this.sync(); if (this.hidden) return [];
      return [...this.querySelectorAll('[data-gift-extra]')].flatMap(row => {
        const option = row.querySelector('[data-extra-color]')?.selectedOptions[0];
        const n = Number(row.querySelector('[data-extra-quantity]').value);
        if (!option || option.disabled || !n) return [];
        if (row.dataset.extraKind === 'throw') return [{id:option.dataset.unit,quantity:n}];
        const items = [];
        if (Math.floor(n / 2)) items.push({id:option.dataset.pair,quantity:Math.floor(n / 2)});
        if (n % 2) items.push({id:option.dataset.unit,quantity:1});
        return items;
      });
    }
  });
}
